<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Dettaglio Responsabile Team
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaModifiche" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva Modifiche</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5">
      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="12" align="center">
            <v-autocomplete
              @change="
                items_utenti.forEach((elem) => {
                  if (elem.id_utente === responsabile_sel_tmp.id_personale) {
                    responsabile_sel_tmp.nominativo = `${elem.nome} ${elem.cognome}`;
                  }
                })
              "
              :items="items_utenti"
              :item-text="(item) => `${item.nome} ${item.cognome}`"
              item-value="id_utente"
              style="max-width: 250px"
              v-model="responsabile_sel_tmp.id_personale"
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import _ from "lodash";
import Responsabile from "@/classes/EMResponsabileTeam.js";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ModificaResponsabile",
  components: { SnackbarQV },
  props: {
    items_id_usati: { type: Array, default: () => [] },
    utente_sel: { type: Object, default: () => {} },
    visible: { type: Boolean, default: false },
  },
  data() {
    return {
      // Variabili d'appoggio
      responsabile_sel_tmp: new Responsabile(),

      // Modal
      overlay: false,

      // Array
      items_utenti: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.responsabile_sel_tmp = new Responsabile(this.utente_sel);
          this.getUtenti();
        }
      },
    },
  },
  methods: {
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    getUtenti() {
      const request = {
        controller: "Modulo",
        method: "POST",
        richiesta: {
          action: "getUtenti",
          token: localStorage.user_token,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            this.items_utenti = Array.from(res.data.result.utenti);
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "error",
              "Errore critico nella comunicazione col server."
            );
          }
        })
        .catch(() => {
          this.overlay = false;
          this.$refs.SnackbarQV.print(
            "error",
            "Errore critico nella comunicazione col server."
          );
        });
    },
    salvaModifiche() {
      if (
        this.items_id_usati.includes(this.responsabile_sel_tmp.id_personale)
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Questa risorsa è già stata impegnata."
        );
        return;
      }

      const obj_tmp = _.cloneDeep(this.responsabile_sel_tmp);
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setpersonale",
          token: localStorage.user_token,
          team: [obj_tmp],
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.$emit("salvate_modifiche");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nello scambio di dati col server."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nello scambio di dati col server."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>